<div class="form-group w-30">
  {{formField.label}}
  <div class="input-group w-100" [formGroup]="formGroup">
    <input class="form-control" [placeholder]="formField.label" [formControlName]="formField.key" ngbDatepicker
      #d="ngbDatepicker" data-date-inline-picker="false" [minDate]="minDate" [maxDate]="formField.maxDate"
      (dateSelect)="dateSelectEvent(formField.key)" />
    <div class="input-group-append">
      <button class="btn btn-outline-secondary calendar rounded-0" (click)="d.toggle()" type="button"
        style="line-height: 2.5;">
        <span class="fa fa-calendar "></span>
      </button>
    </div>
    <div *ngIf="control.errors" class="invalid-feedback">
      <div *ngIf="control.errors.required" class="invalid-feedback">This is
        required</div>
      <div *ngIf="!control.errors.required" class="invalid-feedback">Invalid Date</div>
    </div>

  </div>
</div>